import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TextField from '@mui/material/TextField';
import Drawer from "@mui/material/Drawer";
import axios from "axios";
import dayjs from "dayjs";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import LinearProgress from "@mui/material/LinearProgress";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import DescriptionIcon from "@mui/icons-material/Description"; // For CSV
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
 import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
 import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { api } from "../../../utils/api";
import { companyId, token, userId } from "../../../utils/companyId";
import InputField from "../../../Components/Masters/InputField";
import SelectField from "../../../Components/Masters/SelectField";
import FileField from "../../../Components/Masters/FileField";
import { validateNumber, validateString } from "../../../utils/validateFields";
import { numberError, textError } from "../../../utils/validationMessage";
import Multiline from "../../../Components/Masters/Multiline";
import { color } from "chart.js/helpers";

function AddEmployeeCommute({
  //   inputData,
  fetchData,
  fetchCardData,
  id,
  title,
  data,
  setAddData,
  SelectedData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
}) {
  const [errors, setErrors] = useState({});
  const initialState = {
    files: [],
  };
  const [formData, setFormData] = useState(initialState);
  const [date, setDate] = useState();
  const [time, setTime] = useState();
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState();
  const [progress, setProgress] = useState();
  const [fileUrl, setFileUrl] = useState(0);
  const resetFrom = () => {
    setFormData(SelectedData !== null ? SelectedData : initialState);
    // setUploadedFiles(SelectedData !==null?SelectedData:[]);
    setTime(
      SelectedData !== null ? dayjs(SelectedData?.startDateAndTime?.time) : null
    );
    setDate(
      SelectedData !== null ? dayjs(SelectedData?.startDateAndTime?.date) : null
    );
  };
  // useEffect(() => {

  //    console.log(`dataValues--`,SelectedData,SelectedData?.vendor?.VendorLegalFullName)
  //   if (SelectedData !== null) {
  //     setFormData({
  //       fuelType: SelectedData?.fuelType || "",
  //       source: SelectedData?.source || "",
  //       destination: SelectedData?.destination || "",
  //       vehicle: SelectedData?.vehicle || "",
  //       driver: SelectedData?.driver || "",
  //       associatedVendor: SelectedData?.associatedVendor?._id || "",
  //       driver: SelectedData?.driver?._id || "",
  //       vehicle: SelectedData?.vehicle?._id || "",
  //       distanceTravel:{
  //         value: SelectedData?.distanceTravel?.value || "",
  //         unit: SelectedData?.distanceTravel?.unit || "",
  //       },
  //       fuelConsumed:{
  //         value: SelectedData?.fuelConsumed?.value || "",
  //         unit: SelectedData?.fuelConsumed?.unit || "",
  //       },
  //       declaredEfficiency: SelectedData?.declaredEfficiency || "",

  //     });
  //       setDate(dayjs(SelectedData?.startDateAndTime?.date))
  //     setTime(SelectedData?.startDateAndTime?.time)
  //   //   setUploadedFiles(SelectedData?.documents || []);
  //   }
  //   else{
  //     resetFrom();
  //   }
  // }, [SelectedData]);

  //   const handleChange = (e) => {
  //     const { name, value } = e.target;

  //     console.log(name,value,"forData")
  //     setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
  //     setFormData((prevState) => ({ ...prevState, [name]: value }));
  //   };

  const handleDownloadFile = () => {
    const fileUrl =
      // "https://res.cloudinary.com/ddadiidfn/raw/upload/v1731563845/uploads/Employee_Commute.xlsx?download=1";
      "https://res.cloudinary.com/ddadiidfn/raw/upload/v1740477263/uploads/1740477267410_Employee_Commute%20%28Updated%29%20%281%29.xlsx"
    // window.open(link)
    const link = document.createElement("a");
    link.href = fileUrl;
    link.target = "_blank";
    link.setAttribute("download", "Employee_Commute.xlsx"); // Specify the file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleChangeDate = (e) => {
    console.log(e.toISOString().split("T")[0], "for data date");
    setDate(e);

    setFormData((prevState) => ({
      ...prevState,
      startDateAndTime: {
        ...prevState.startDateAndTime,
        date: e.toISOString().split("T")[0],
      },
    }));
  };
  const handleChangeTime = (e) => {
    const { name, value } = e.target;
    console.log(e.target.value, "for data date");
    // setDate(value);
    setTime(value);
    // const date = value.toISOString().split("T")[0]; // Extract the date in "YYYY-MM-DD" format
    // const time = value.toTimeString().split(" ")[0];
    setFormData((prevState) => ({
      ...prevState,
      startDateAndTime: {
        ...prevState.startDateAndTime,
        time: value,
      },
    }));
  };
  const checkImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        const { width, height } = img;
        resolve({ width, height });
      };
      img.onerror = () => {
        reject(new Error("Failed to load image"));
      };
    });
  };

  const handleFileChange = async (e) => {
    const { name, files } = e.target;
    console.log("File changed:", name, "Files:", files);

    setErrors((prevErrors) => ({ files: "" }));

    if (!files || files.length === 0) return;

    if (fileUrl.length + files.length > 1) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: ["You cannot upload more than 1 file."],
      }));
      return;
    }
    // const progressTracker = Array(files.length).fill(0);
    const newErrors = [];
    const uploadedUrls = [];
    const allowedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];
    const maxFileSize = 5 * 1024 * 1024; // 5 MB

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      console.log("Processing file:", file);
      setFormData({ files: file });
      setUploadedFiles([file]);
      // Check file type
      if (!allowedTypes.includes(file.type)) {
        newErrors.push(`File type not allowed: ${file.name}`);
        continue;
      }

      // Check file size
      if (file.size > maxFileSize) {
        newErrors.push(`File size exceeds 5MB: ${file.name}`);
        continue;
      }

      // Create FormData for the file

      //   try {
      //     // Upload the file to the backend
      //     const res = await axios.post(`${api}/scope3/employeeCommute/uploadEmployee`, formData, {
      //       headers: {
      //         "Content-Type": "multipart/form-data",
      //       },
      //       onUploadProgress: (progressEvent) => {
      //         const percent = Math.round(
      //           (progressEvent.loaded * 100) / progressEvent.total
      //         );
      //         progressTracker[i] = percent;
      //         setUploadProgress((prev) => ({ ...prev, [name]: progressTracker }));
      //       },
      //     });
      //     setFileUrl(files.length)
      //     // setUploadProgress(files.length)
      //     // Extract uploaded file URL
      //     if (res.data) {
      //       uploadedUrls.push(file);
      //       console.log("File uploaded successfully:", res.data);
      //     } else {
      //       newErrors.push(`Failed to get the uploaded URL for: ${file.name}`);
      //     }
      //   } catch (error) {
      //     setFileUrl(files.length)
      //     console.error("File upload error:", error);
      //     newErrors.push(`Failed to upload file: ${file.name}`);
      //   }
    }

    // Update state with uploaded files

    // Handle upload errors
    if (newErrors.length > 0) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: newErrors }));
    }
  };

  const handleClose = () => {
    setAddData(false);
    setErrors({});
    resetFrom();
  };

  const validateForm = () => {
    const newErrors = {};
    console.log(formData.files.length, formData, "formData.files");
    if (!formData.files || formData.files.length === 0) {
      newErrors.files = "Please upload the file";
    }
    // console.log(formData)

    console.log(newErrors, "newErrors");
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const formatFileName = (fileName) => {
    return decodeURIComponent(fileName);
  };

  //   const documentFiles = fileUrl.length > 0 && uploadedFiles.filter((File) => {
  //     if (File && File.name) {
  //       const fileExtension = File.name.split(".").pop().toLowerCase();
  //       return ["csv", "xls", "xlsx"].includes(fileExtension);
  //     }
  //     return false; // If the file or file.name is invalid, exclude it
  //   });

  console.log("uploadedFiles", uploadedFiles);
  const documentFiles = uploadedFiles.filter((file) => {
    if (file && typeof file.name === "string") {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      return ["csv", "xls", "xlsx"].includes(fileExtension);
    }
    return false;
  });
  console.log("uploadedFiles", uploadedFiles, documentFiles);
  const Save = async () => {
    if (!validateForm()) return;
    console.log("insideSave", formData.files);
    let progressTracker = Array(formData.files.length).fill(0);
    const formDatas = new FormData();
    formDatas.append("files", formData.files);

    try {
      const tkn = sessionStorage.getItem("token") || token;

      // Upload the file to the backend
      const res = await axios.post(
        `${api}/scope3/employeeCommute/uploadEmployee`,
        formDatas,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${tkn}`, // Add the Bearer token here
          },
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            progressTracker = percent;
            //   setUploadProgress();
          },
        }
      );
      setFileUrl(formData.files.length);
      // setUploadProgress(files.length)
      // Extract uploaded file URL
      if (res.data) {
        // uploadedUrls.push(file);
        handleClose();
        fetchData();
        fetchCardData();
        console.log("File uploaded successfully:", res.data);
      } else {
        // newErrors.push(`Failed to get the uploaded URL for: ${files.name}`);
      }
    } catch (error) {
      setFileUrl(formData.files.length);
      console.error("File upload error:", error);
      //   newErrors.push(`Failed to upload file: ${file.name}`);
    }
  };

  const fileUploadHandler = () => {
    return (
      <Box sx={{ mt: 2 }}>
        {documentFiles.length > 0 && (
          <Box mb={2} sx={{ width: "100%" }}>
            <Box display="flex" flexWrap="wrap" gap={1}>
              {documentFiles.map((file, index) => {
                const fileName = file.name; // Access the file name
                const fileExtension = fileName.split(".").pop().toLowerCase();
                const isCsv = fileExtension === "csv";
                const isExcel = ["xls", "xlsx"].includes(fileExtension);

                return (
                  <Box
                    key={index}
                    sx={{
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                      width: "45%",
                      minWidth: "100px",
                      overflowX: "hidden",
                    }}
                  >
                    {isCsv ? (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          padding: 1,
                          width: "100%",
                        }}
                      >
                        <DescriptionIcon
                          sx={{
                            fontSize: "20px",
                            color: "#1A73E8",
                            marginRight: "5px",
                          }}
                        />
                        <Typography
                          variant="caption"
                          noWrap
                          sx={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {fileName}
                        </Typography>
                      </Box>
                    ) : isExcel ? (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          padding: 1,
                          width: "100%",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faFileExcel}
                          style={{ marginRight: "5px", color: "#0a8f08" }}
                        />
                        <Typography
                          variant="caption"
                          noWrap
                          sx={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {fileName}
                        </Typography>
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          width: "80px",
                          height: "80px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          marginBottom: "10px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        <Typography variant="caption" noWrap>
                          {fileName}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                );
              })}
            </Box>
          </Box>
        )}

        {/* {uploadProgress > 0 && (
      <Box sx={{ mt: 1, mb: 1, width: "100%" }}>
        <LinearProgress value={uploadProgress} sx={{ width: "100%" }} />
      </Box>
    )} */}

        <Box
          sx={{
            border: "1px dashed grey",
            borderRadius: 1,
            p: 2,
            textAlign: "center",
            cursor: "pointer",
            width: "100%",
          }}
        >
          <input
            type="file"
            hidden
            id={`upload-document`}
            name={`upload-document`}
            onChange={handleFileChange}
            multiple
          />
          <label htmlFor={`upload-document`}>
            <Box display="flex" flexDirection="column" alignItems="center">
              <CloudUploadIcon />
              <Typography>Drop files here or click to upload</Typography>
              <Typography variant="caption">
                Upload your file (CSV, Excel, PNG, max 5 MB, recommended size
                1200x800 pixels).
              </Typography>
            </Box>
          </label>
        </Box>

        {errors && (
          <Typography variant="body2" color="#D34040">
            {errors.files}
          </Typography>
        )}
      </Box>
    );
  };

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "400px", height: "100vh" }}>
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          width: "88%",
          p: 3,
          backgroundColor: "#fff",
          height: "100%",
          overflowY: "auto",
        }}
      >
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          Upload Data
          {/* AddData */}
        </Typography>
        <Typography
          variant="h6"
          style={{ fontSize: "16px", fontWeight: "600" }}
        >
          Step1 : Download The <span style={{ color: "green" }}> .excel</span>{" "}
          File
        </Typography>
        <p style={{ margin: "11px 0px 0px 59px", fontSize: "15px" }}>
          Kindly Download the excel file to Continue Filling Data
        </p>

        <Button
          sx={{
            color: "#fff",
            background: "#0a3f73",
            width: "100%",
            p: 1,
            mt: 5,
            fontSize: "13px",
            "&:hover": {
              background: "#0a3f73", // Slightly lighter blue on hover
            },
          }}
          onClick={handleDownloadFile}
        >
          Click Here To Download
        </Button>

        <Typography
          variant="h6"
          style={{ fontSize: "15px", marginTop: "25px", fontWeight: "600" }}
        >
          Step2 : File The Sheet Document & Save
        </Typography>
        <p style={{ margin: "11px 0px 0px 59px", fontSize: "15px" }}>
          File the downloaded excel sheet & save it on local storage
        </p>
        <Typography
          variant="h6"
          style={{ fontSize: "16px", fontWeight: "600", marginTop: "25px" }}
        >
          Step3 : Upload The Filled{" "}
          <span style={{ color: "green" }}> .excel</span> File
        </Typography>
        <p style={{ margin: "11px 0px 0px 59px", fontSize: "15px" }}>
          Kindly Upload The Saved Excel file here
        </p>

        <div>{fileUploadHandler()}</div>

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          // minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {list()}
    </Drawer>
  );
}

export default AddEmployeeCommute;
